import { BaseApi } from './base.api.js';

export class ScenarioTimelineApi extends BaseApi {
    constructor(client) {
        super(client, '/scenario-timelines');
    }
}
